import { render, staticRenderFns } from "./biRecordJoin.vue?vue&type=template&id=46bbb497&scoped=true&"
import script from "./biRecordJoin.vue?vue&type=script&lang=js&"
export * from "./biRecordJoin.vue?vue&type=script&lang=js&"
import style0 from "./biRecordJoin.vue?vue&type=style&index=0&id=46bbb497&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bbb497",
  null
  
)

export default component.exports